// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3QEJd","text":"style_text__2TFmQ","button":"style_button__1D2Ey","active":"style_active__2rJRg","disable":"style_disable__11_1a"};